import colors from './colors'
import dimensions from './dimensions'

export default {
  colors,
  dimensions
}
